<form [formGroup]="form" class="flex-direction-column m-t-md" layout>
  <cc-box>
    <div class="header" header box>
      <span translate>MSISDN.ASSIGN_PROJECTS</span>
    </div>

    <div content box>
      <div class="content" layout>
        <label translate>MSISDN.ASSIGN_NUMBER_TO_PROJECTS</label>
        <div class="input-error">
          <mat-select
            formControlName="projectIds"
            placeholder="{{'CHOOSE' | translate}}"
            multiple
          >
            <mat-option disabled="disabled" class="option-menu">
              <div (click)="gotoNewProject()" class="pointer option-menu-item">
                <span translate>LEAD_GENERATION.ADD_NEW_PROJECT</span>
              </div>
              <div (click)="selectAllProjects()" class="pointer option-menu-item" translate>LEAD_GENERATION.SELECT_ALL
              </div>
              <div (click)="unselectAllProjects()" class="pointer option-menu-item" translate>
                LEAD_GENERATION.UNSELECT_ALL
              </div>
            </mat-option>
            <mat-option
              *ngFor="let item of projects"
              [value]="item.id"
            >{{item.name}}
            </mat-option>
          </mat-select>
          <cc-input-errors
            [form]="form"
            inputName="projectIds"
            [errors]="[{'required': 'MSISDN.CHOOSE_PROJECTS' | translate}]">
          </cc-input-errors>
        </div>
      </div>
    </div>
  </cc-box>
</form>
